import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum DocumentCategoryColumn {
    NAME = "name",
    DESCRIPTION = "description",
    PERCENTAGE = "percentage",
    DOCUMENTS = "documents",
    ACTIONS = "actions",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(DocumentCategoryColumn.NAME),
});

const DescriptionColumnSchema = ColumnSchema.extend({
    id: z.literal(DocumentCategoryColumn.DESCRIPTION),
});

const PercentageColumnSchema = ColumnSchema.extend({
    id: z.literal(DocumentCategoryColumn.PERCENTAGE),
});

const DocumentsColumnSchema = ColumnSchema.extend({
    id: z.literal(DocumentCategoryColumn.DOCUMENTS),
});

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(DocumentCategoryColumn.ACTIONS),
});

export const DocumentCategoriesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.DOCUMENT_CATEGORIES),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            DescriptionColumnSchema,
            PercentageColumnSchema,
            DocumentsColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type DocumentCategoriesView = z.infer<
    typeof DocumentCategoriesViewSchema
>;
